/**
 * LocalStorage key for restoring the requested URL after login redirect.
 */
export const GMS2_POST_LOGIN_REDIRECT = 'gms2_postLoginRedirect';

/**
 * LocalStorage key prefix for selected org (same format as point-o-gms useDefaultOrg).
 * Full key: gms-selected-org-${auth0Sub}
 */
export const GMS2_SELECTED_ORG_KEY_PREFIX = 'gms-selected-org';

export const getGms2SelectedOrgStorageKey = (auth0Sub: string): string =>
  `${GMS2_SELECTED_ORG_KEY_PREFIX}-${auth0Sub}`;
